import axios from '@/plugins/axios'
import alert from '@/plugins/alert'
import utils from '@/plugins/utils'
import api, { UserMeta } from '../../plugins/api'
import { get, last } from 'lodash'

const USER_API = '/users/'

export default {
  namespaced: true,
  state: {
    users: [],
    count: 0,
    user: null
  },
  actions: {
    updateUser({ commit, rootState }, { id, ...user }) {
      return axios
        .put(USER_API + id, user)
        .then(updatedUser => {
          const transedUser = updatedUser
          commit('setUser', transedUser)
          commit('receiveUser', transedUser)
          commit('class/updateUser', transedUser, { root: true })
          if (rootState.auth.user && rootState.auth.user.id === transedUser.id) {
            commit('auth/setUser', transedUser, { root: true })
          }
          // alert.success('User updated!')
        })
        .catch(e => alert.error(e))
    },
    // eslint-disable-next-line
    async validateEmail({}, email) {
      let errMsg = !!email || 'Trường này là bắt buộc'
      errMsg = errMsg === true ? /.+@.+/.test(email) || 'E-mail không hợp lệ' : errMsg
      if (errMsg === true) {
        const users = await api.User.search({ email, _limit: 1 })
        if (users.length > 0) {
          errMsg = 'Email này đã được sử dụng'
        }
      }
      return errMsg === true ? '' : errMsg
    },
    // eslint-disable-next-line
    async generateUserName({ dispatch }, name = '') {
      let userNameIndex = utils.generateUserName(utils.clearUnicode(name))
      let userNo = 0
      userNameIndex = utils.removeUnicode(userNameIndex).toLowerCase()
      const users = await api.User.search({
        username_indexing: userNameIndex,
        type_ne: 'student',
        _sort: 'username_no:DESC',
        _limit: 1
      })
      if (users.length) userNo = get(last(users), 'username_no', 0) + 1
      return {
        username: `${userNameIndex}${userNo || ''}`,
        username_indexing: userNameIndex,
        username_no: userNo
      }
    },
    async generateStudentCode({ dispatch }, name = '') {
      const nameArr = name.split(' ')
      if (nameArr[nameArr.length - 1].length === 1) {
        name = name.slice(0, -1).trim()
      }

      let userNameIndex = utils.generateUserName(utils.clearUnicode(name))
      userNameIndex = utils.removeUnicode(userNameIndex).toLowerCase()

      const userMeta = await api.UserMeta.fetch()
      const userNo = get(userMeta, 'indexUser', 0) + 1
      const code = `00000${userNo}`.substr(`00000${userNo}`.length - 5)
      return {
        username: `${code}${userNameIndex}`,
        username_indexing: userNameIndex,
        username_no: userNo
      }
    },
    async changePassword({ commit }, data) {
      const oldPasswordEncode = window.btoa(window.btoa(data.oldPassword))
      const newPasswordEncode = window.btoa(window.btoa(data.newPassword))
      const params = {
        userId: data.userId,
        oldPasswordEncode,
        newPasswordEncode
      }
      await UserMeta.changePassword(params)
    },
    async resetTeacherPassByAdmin({ commit }, { id, newPassword }) {
      if (id && newPassword) {
        await api.User.update(id, {
          password: newPassword
        })
      }
    }
  },
  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setUser(state, user) {
      state.user = user
    },
    receiveUser(state, user) {
      const i = state.users.findIndex(({ id }) => user.id === id)
      if (i > -1) {
        state.users.splice(i, 1, user)
      } else {
        state.users.unshift(user)
      }
    },
    removeUser(state, userId) {
      const i = state.users.findIndex(user => user.id === userId)
      if (i > -1) state.users.splice(i, 1)
    }
  }
}
